import type { SurveyResource } from '@dmp/qqms/data-access';
import type {
    StateGetter,
    StateSetter,
    SubState,
    SurveyState,
} from '../../state-types';
import { resolveSubState } from '../../state-utils';
import { setSurveyFromResource } from './set-survey-from-resource';
import { updateSurvey } from './update-survey';
import { updateSurveyTheme } from './update-survey-theme';

export const surveyActions = (set: StateSetter, get: StateGetter) => ({
    /** Set survey (consume) from the data received from the resource and transform it into the state. This is used when the survey is loaded from the API. */
    setSurveyFromResource: (surveyResource: SurveyResource) =>
        set(setSurveyFromResource(surveyResource), true),

    /** Update partial survey */
    updateSurvey: (partialSurvey: Partial<SurveyState>) =>
        set(updateSurvey(partialSurvey), true),

    /** Update survey placement - accepts either a new placement or a function that receives current placement */
    updateSurveyPlacement: (placement: SubState<SurveyState['placement']>) => {
        const newPlacement = resolveSubState(placement, get().survey.placement);
        set(updateSurvey({ placement: newPlacement }), true);
    },

    /** Update partial theme */
    updateSurveyTheme: (partialTheme: Partial<SurveyState['theme']>) =>
        set(updateSurveyTheme(partialTheme), true),
});
